// extracted by mini-css-extract-plugin
export var actionButton = "_r7-0";
export var actionMenuContainer = "_r7-i";
export var bubble = "_r7-2";
export var bubbleActionMenu = "_r7-j";
export var bubbleContext = "_r7-6";
export var bubbleItems = "_r7-7";
export var customer = "_r7-3";
export var divider = "_r7-8";
export var fileList = "_r7-9";
export var hiddenComment = "_r7-o";
export var infoAbove = "_r7-a";
export var internal = "_r7-4";
export var lightActionButton = "_r7-1";
export var link = "_r7-b";
export var merchant = "_r7-5";
export var message = "_r7-c";
export var profilePicture = "_r7-e";
export var quillToolbarContainer = "_r7-f";
export var senderDate = "_r7-g";
export var senderDateCustomer = "_r7-h";
export var senderName = "_r7-d";
export var time = "_r7-k";
export var uploadedImage = "_r7-l";
export var username = "_r7-m";
export var xsmall = "_r7-n";